import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { payMobx } from '@mobxStore'
import BankCardSimpleItem from './SimpleItem'

const MethodItem = ({ method, selected, bankCards, onChange }: { method: any; selected?: boolean; bankCards?: any[]; onChange: any }) => {
  const amount = method?.amount
  const card = method?.card
  const channel = method?.channel

  useEffect(() => {
    payMobx.loadAccount(payMobx.methodChannelMap.bankCardOnline)
  }, [])
  return (
    <BankCardSimpleItem bankCards={bankCards} selected={selected} amount={amount} channel={channel} onChange={onChange} card={card} />
  )
}

export default observer(MethodItem)
